import { NgModule, ApplicationRef } from '@angular/core';
import { UrlSerializer } from '@angular/router';
import { BrowserModule, DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpModule ,Http} from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'hammerjs';
import { SelectModule } from 'ng2-select';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';
import { PreloaderDirective } from './layout/preloader.directive';
import { AppHeaderComponent } from './layout/header/header.component';
import { AppSidenavComponent } from './layout/sidenav/sidenav.component';
import { ToggleOffcanvasNavDirective } from './layout/sidenav/toggle-offcanvas-nav.directive';
import { AutoCloseMobileNavDirective } from './layout/sidenav/auto-close-mobile-nav.directive';
import { AppSidenavMenuComponent } from './layout/sidenav/sidenav-menu/sidenav-menu.component';
import { AccordionNavDirective } from './layout/sidenav/sidenav-menu/accordion-nav.directive';
import { AppendSubmenuIconDirective } from './layout/sidenav/sidenav-menu/append-submenu-icon.directive';
import { HighlightActiveItemsDirective } from './layout/sidenav/sidenav-menu/highlight-active-items.directive';
import { AppCustomizerComponent } from './layout/customizer/customizer.component';
import { ToggleQuickviewDirective } from './layout/customizer/toggle-quickview.directive';
import { Daterangepicker } from 'ng2-daterangepicker';
import { AppFooterComponent } from './layout/footer/footer.component';
import { AppSearchOverlayComponent } from './layout/search-overlay/search-overlay.component';
import { SearchOverlayDirective } from './layout/search-overlay/search-overlay.directive';
import { OpenSearchOverlaylDirective } from './layout/search-overlay/open-search-overlay.directive';
import { LoaderComponent } from './loader/loader.component';
import { LoaderService  } from './loader/loader.service';
import { dialogComponent,termsDialogComponent, icbtermsDialogComponent, privacyComponent} from './dialog/dialog.component';
import { CommonService } from './shared/services/common.service';
import { dashboardResultService } from './dashboardResultService';
import { icb_dashboardResultService } from './icb_dashboard/icb_dashboardResultService';
import { DashboardComponent,searchDialog, viewDialog, DownloadComponent , UPSUpdateComponent,createUPSDialogComponent} from './dashboard/dashboard.component';
import { ViewProgressDialog } from './progress-status/progress.component';
import { ViewDocDialog } from './icb/t2c/summary/summary.component';
import { ViewImagesDialog } from './icb/t2c/data/data.component';
import { FocRequestComponent } from './foc_request/foc_request.component';


import { icbSearchDialog, icb_dashboardComponent } from './icb_dashboard/icb_dashboard.component';
import { InspectionComponent } from './inspection/inspection.component';
import { adminComponent } from './admin/admin.component';
import { addApproverComponent } from './admin/addApprover.component';
import { PageLayoutFullscreenComponent } from './page-layouts/fullscreen/fullscreen.component';
import { PageLoginComponent } from './login/login.component';
import {HomeComponent } from './home/home.component';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { RequestsModule } from './request-mgmt/requests.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { viewRequestsModule } from './viewRequest/viewrequests.module';
import { FOCviewRequestsModule } from './FOCviewRequest/foc-viewrequests.module';
import { TradesModule } from './trade/trade.module';
import { IcbModule } from './icb/icb.module';
import { SOCDetailsModule } from './socIdDetails/socIdDetails.module';
import { SOCDetailsActionComponent } from './dialog/dialog.component';
import { LowerCaseUrlSerializer } from './app.url_serializer';
import { IonRangeSliderModule } from "ng2-ion-range-slider"; 
import {ToasterModule} from 'angular2-toaster';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { removeNgStyles, createNewHosts } from '@angularclass/hmr';
import {TranslateModule,TranslateLoader,TranslateStaticLoader} from 'ng2-translate';
import { MdButtonModule, MdDialog, MdDialogRef, MaterialModule } from '@angular/material';
import { AccordionComponent } from '../app/layout/sidenav/sidenav-menu/accordion/accordion.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FocDashboardComponent } from './foc-dashboard/foc-dashboard.component';
import { FocAdminComponent } from './foc-admin/foc-admin.component';
import { FOCaddApproverComponent } from './foc-admin/foc-addApprover.component';
import { focSearchDialog } from './foc-dashboard/foc-dashboard.component';

import { FOCRequestsModule } from './request-mgmt-foc/foc-requests.module';
import { focDownloadComponent } from './foc-dashboard/foc-dashboard.component';
// Ensure the correct path to the module is used
import { FileUploadModule } from './fileUpload.module';
@NgModule({
    imports: [
        
        MdButtonModule,
        IonRangeSliderModule,
        ToasterModule,
        BrowserModule,
        HttpModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        LayoutModule,
        SharedModule,
        RequestsModule,
        DashboardModule,
        IcbModule,
        viewRequestsModule,
        FOCviewRequestsModule,
        TradesModule,
        NgxDatatableModule,
        FOCRequestsModule,
        Daterangepicker,
        SelectModule,
        SOCDetailsModule,
        PdfViewerModule,
        FileUploadModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
            deps: [Http]
        })

    ],
    declarations: [
        
        HomeComponent,
        AccordionComponent,
        AppComponent,
        LayoutComponent,
        PreloaderDirective,
        AppHeaderComponent,
        AppSidenavComponent,
        ToggleOffcanvasNavDirective,
        AutoCloseMobileNavDirective,
        AppSidenavMenuComponent,
        AccordionNavDirective,
        AppendSubmenuIconDirective,
        HighlightActiveItemsDirective,
        AppCustomizerComponent,
        ToggleQuickviewDirective,
        AppFooterComponent,
        AppSearchOverlayComponent,
        SearchOverlayDirective,
        OpenSearchOverlaylDirective,
        DashboardComponent,
        icb_dashboardComponent,
        InspectionComponent,
        adminComponent,
        PageLayoutFullscreenComponent,
        PageLoginComponent,
        LoaderComponent,
        FocRequestComponent,
        dialogComponent,
        termsDialogComponent,
        icbtermsDialogComponent,
        privacyComponent,
        searchDialog,
        viewDialog,
        ViewProgressDialog,
        ViewDocDialog,
        ViewImagesDialog,
        addApproverComponent,
        SOCDetailsActionComponent,
        UPSUpdateComponent,
        createUPSDialogComponent,
        FocDashboardComponent,
        icbSearchDialog,
        FocAdminComponent,
        FOCaddApproverComponent,
        focSearchDialog,
        focDownloadComponent
        
        
        
    ],
    providers: [
        LoaderService,dashboardResultService,icb_dashboardResultService,CommonService,
        {provide: UrlSerializer, useClass: LowerCaseUrlSerializer}
    ],
    entryComponents: [dialogComponent,termsDialogComponent,icbtermsDialogComponent,privacyComponent,searchDialog,ViewImagesDialog,viewDialog,ViewProgressDialog,ViewDocDialog,DownloadComponent,SOCDetailsActionComponent,addApproverComponent,focDownloadComponent,FOCaddApproverComponent,UPSUpdateComponent,createUPSDialogComponent,icbSearchDialog, focSearchDialog],
    bootstrap: [AppComponent]
})

export class AppModule {
    constructor(public appRef: ApplicationRef) {
    //   console.log=function(){}
    }
    hmrOnInit(store) {
        console.log('HMR store', store);
    }
    hmrOnDestroy(store) {
        let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
        store.disposeOldHosts = createNewHosts(cmpLocation);
        removeNgStyles();
    }
    hmrAfterDestroy(store) {
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.module.ts